import React, { useState, FC, useEffect } from "react";
import { Link } from "gatsby";
import { User } from "../../../models/user";
import Button from "../../common/button/button";
import CreatedAlbums from "./createdAlbums";
import OwnedAlbums from "./ownedAlbums";
import TokenSummary from "./tokenSummary";
import { FullAlbumDetails, OwnedAlbumDetails } from "../../../models/exports";

interface AlbumsTabProps {
  createdAlbums: FullAlbumDetails[];
  createdAlbumsLoading: boolean;
  ownedAlbums: OwnedAlbumDetails[];
  ownedAlbumsLoading: boolean;
  profilePage?: boolean;
}

const AlbumsTab: FC<AlbumsTabProps> = ({
  createdAlbums,
  createdAlbumsLoading,
  ownedAlbums,
  ownedAlbumsLoading,
  profilePage = false,
}) => {
  return (
    <div className="flex flex-col w-full" style={{ minHeight: "60vh" }}>
      {/* albums created */}
      <CreatedAlbums
        createdAlbums={createdAlbums}
        loading={createdAlbumsLoading}
        profilePage={profilePage}
      />
      <OwnedAlbums
        ownedAlbums={ownedAlbums}
        loading={ownedAlbumsLoading}
        profilePage={profilePage}
      />
      <TokenSummary ownedAlbums={ownedAlbums} loading={ownedAlbumsLoading} />
    </div>
  );
};

export default AlbumsTab;
